export function groupPropertiesByPrefix<T extends Record<string, any>>(
  obj: T,
  prefix: string
): Record<string, any> {
  const result: Record<string, any> = {};
  const groupedProperties: Record<string, any> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (key.startsWith(prefix)) {
        const newKey = key.slice(prefix.length);
        groupedProperties[newKey] = obj[key];
      } else {
        result[key] = obj[key];
      }
    }
  }

  if (Object.keys(groupedProperties).length > 0) {
    result[prefix.slice(0, -1)] = groupedProperties;
  }

  return result;
}
